const MODULE_NAME = 'fulcrum/containers/Form/Util/Validation'

export {
  MODULE_NAME
}
